module.exports = __webpack_public_path__ + "static/sheep5-04bd0e7473a1463c6c096e34c6dd89f5.jpeg";